console.time("AppReady");
import {
	EventDispatcher,
	DomUtil
} from "cartovista";
import CartovistaExtend from "cartovistaExtend/CartovistaExtend";
import BbGraphs from "cartovistaExtend/panels/BbGraphs";
import Constat from "cartovistaExtend/panels/Constat";
import MasterBtnThemeSetList from "cartovistaExtend/mapTools/MasterBtnThemeSetList";
import {loadData, createLayers, createThemeSetsElements, initZoomLayeringLayers} from "./ServerDataHandlers";
import { Modal } from 'bootstrap';
import "../styles/atlas_decrochage.css";

    class App extends EventDispatcher {
        constructor(cartovista) {
            super();
            this.cartovista = cartovista;
            window.cartovista.addOneTimeEventListener(window.cartovista.EVENTS.MAP_LOADED + "_" + C.MAP.ID, this._onCartoVistaMapLoaded, this);
            window.cartovista.addOneTimeEventListener("ServerDataInitialized", this._onServerLayersLoaded, this);
            loadData();
            this._onThemeSetAppliedDataLoaded = false;
        }

    _onCartoVistaMapLoaded() {
        this._map = window.cartovista.externalInterface.map;
        
        this._mapController = window.cartovista.getMapController(this._map);
        window.cartovista.resizeRightVerticalSplitter(365);
        createLayers();
        createThemeSetsElements();
        initZoomLayeringLayers();
        if (!DomUtil.isResponsiveUI()) {
            window.cartovista.getUIController(this._map).findInstance("dataView-selectedFeatures")._activateOnSelectionChanged = false;
        }
        this._loadCustomModules();
    }

    _onServerLayersLoaded() {
        console.timeEnd("AppReady");
        $("#preloader").remove();
        new MasterBtnThemeSetList("2023_2024");
        this._map.activeThemeSet = this._map.getThemeSet("Freq_CS_FRA_ST_1");
        this._map.addEventListener(this._map.EVENTS.ACTIVE_THEME_SET_CHANGED, this._onThemeSetChanged, this);
        new Modal('#IntroModal').show();
    }

    //inclure les modules custom
    _loadCustomModules() {
        new Constat();
        new BbGraphs();
    }

    _onThemeSetChanged() {
        if (!DomUtil.isResponsiveUI()) {
			if (this._map.activeThemeSet && this._map.activeThemeSet.id.indexOf("Provincial") > -1) {
				this.activeBottomSidebarGroup = window.cartovista.getUIController(this._map).getActiveToggledItem("bottomSidebarGroup") ? window.cartovista.getUIController(this._map).getActiveToggledItem("bottomSidebarGroup").associatedContainer : null;
				this.activeBottombarGroup = window.cartovista.getUIController(this._map).getActiveToggledItem("bottombarGroup") ? window.cartovista.getUIController(this._map).getActiveToggledItem("bottombarGroup").associatedContainer : null;
				this.activeTopSidebarGroup = window.cartovista.getUIController(this._map).getActiveToggledItem("topSidebarGroup") ? window.cartovista.getUIController(this._map).getActiveToggledItem("topSidebarGroup").associatedContainer : null;
				if(this.activeBottomSidebarGroup) this.activeBottomSidebarGroup.deactivate();
				if(this.activeBottombarGroup) this.activeBottombarGroup.deactivate();
				window.cartovista.getUIController(this._map).findInstance("Constat_panel").activate();
			} else {
				if(this.activeBottomSidebarGroup) this.activeBottomSidebarGroup.activate();
				if(this.activeBottombarGroup) this.activeBottombarGroup.activate();
				if(this.activeTopSidebarGroup) this.activeTopSidebarGroup.activate();
				this.activeBottomSidebarGroup = null;
				this.activeBottombarGroup = null;
				this.activeTopSidebarGroup = null;
                window.cartovista.getUIController(this._map).findInstance("BbGraphs_rightPanel").activate();
			}
        }
    }
}

$().ready(function() {
	new App(new CartovistaExtend());
});
